import { render, staticRenderFns } from "./CallSectionIcon.vue?vue&type=template&id=656cb1df"
import script from "./CallSectionIcon.vue?vue&type=script&lang=js"
export * from "./CallSectionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports